/**
 * Fonctions de la maquette dont l'écran n'est pas encore converti (paiement d'une échéance,
 * versement rapide). Les boutons qui les appellent existent déjà dans la maquette : ils sont donc présents.
 */
export function openPayLigneModal(_ligneId: string): void {}
export function openQuickVersementPicker(): void {}
export function quickAddDocument(_inscriptionId: string, _typeDocumentId: string): void {}
export function openAddEcueModal(_ueId: string): void {}
export function openQuickVersement(_inscriptionId: string): void {}
